import { Card, Row, Col, Image, Spin, Modal, message, Button, Table, Alert } from "antd";
import logo from "../../assets/images/NewLogoCW.svg";
import red from "../../assets/images/red.svg";
import green from "../../assets/images/green.svg";
import posImg from "../../assets/images/posImg.svg";
import db from "../../database";
import dayjs from "dayjs";
import { v4 as uuidv4 } from "uuid";
import { timeStamp } from "../../utils/timestamp";
import { useEffect, useState, useRef } from "react";
import { LoadingOutlined, MedicineBoxOutlined } from "@ant-design/icons";
import { getOAuthHeaders } from "../../constants/oAuthValidation";
import { useHistory } from "react-router-dom";
import { getTills, posConfigService, syncTillData, upsertPOSActivity } from "../../services";
import { useTranslation } from "react-i18next";
import { getMultilingualText } from "../../utils/getMultilingualText";
import laptop3 from "../../assets/images/laptop3.svg";
import Scrollbars from "react-custom-scrollbars";
import { getStoreOps, upsertStoreOps, tillRegistration } from "../../services";
import SyncSide from "../../assets/images/sideFullSync.svg";
import messages from "../../errors/messages.en-IN.json";
import PostCloseSalesModal from "./PostCloseSalesModal";
import useAuthStore from "../../stores/useAuthStore";
import usePOSConfigStore from "../../stores/usePOSConfigStore";
import useCartStore from "../../stores/useCartStore";
import useSessionStore from "../../stores/useSessionStore";
import useTransactionStore from "../../stores/useTransactionStore";
import useRestaurantStore from "../../stores/useRestaurantStore";
import useReferenceStore from "../../stores/useReferenceStore";
import { trace } from "../../utils/debugTrace";
import { getLocalMaxSequence } from "../../utils/documentSequenceUtils";

const Till = () => {
  const { t } = useTranslation();
  const multilingual = process.env.REACT_APP_MULTILINGUAL === "true" && localStorage.getItem("selectedLanguage") !== "English";
  const redirectUrl = process.env.REACT_APP_redirectURL;
  const [runEffect, setRunEffect] = useState(true);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [tills, setTills] = useState();
  const [tillLoadError, setTillLoadError] = useState(null);
  const [tillValue, setTillValue] = useState(() => {
    // Clear stale tillValue on entry so a previous selection doesn't persist
    const stored = useAuthStore.getState().tillValue;
    return stored || {};
  });
  const [errorModalVisible, setErrorModalVisible] = useState(false);
  const [errorProducts, setErrorProducts] = useState([]);
  const [postCloseModalVisible, setPostCloseModalVisible] = useState(false);
  const [postCloseData, setPostCloseData] = useState({
    storeClosedDate: "",
    newBusinessDate: "",
    closedTime: "",
    tillId: "",
    cashierName: "",
  });
  const retryCountRef = useRef(0);
  const MAX_RETRIES = 3;
  const islocked = useSessionStore.getState().locked;
  let email = "";
  let Enterprise = "";
  let username;
  let cleanToken;
  const authHeaders = getOAuthHeaders();
  console.debug("[AUTH-DIAG] Till auth check", {
    hasAuthHeaders: !!authHeaders,
    hasAccessToken: !!authHeaders?.access_token,
    hasEmail: !!authHeaders?.email,
    hasUsername: !!authHeaders?.username,
    islocked,
    hasTillValue: !!tillValue && Object.keys(tillValue).length > 0,
  });
  if (authHeaders && authHeaders.access_token && (authHeaders.email || authHeaders.username)) {
    email = authHeaders.email;
    Enterprise = authHeaders.Enterprise;
    cleanToken = authHeaders.access_token;
    username = authHeaders.username;
  } else {
    console.warn("[AUTH-DIAG] Till → redirecting to /sign-in (no valid auth)");
    history.push("/sign-in");
  }

  const handleStoreOpsService = async (bunitId) => {
    const posConfig = usePOSConfigStore.getState().posConfig;
    const tillData = useAuthStore.getState().tillData;
    const dayEndPreferences = JSON.parse(tillData?.dayEndPreferences || "[]");
    trace("Till", "handleStoreOpsService", {
      bunitId,
      disableOffline: posConfig?.disableOfflineBilling,
      tillAccessType: Array.isArray(tillData?.tillAccess) ? "ARRAY" : typeof tillData?.tillAccess,
      hasCsBunit: !!tillData?.tillAccess?.csBunit,
    });
    if (posConfig?.disableOfflineBilling === "Y" && dayEndPreferences[0]?.postCloseSalesDate === "NXT") {
      const tillEvents = await db?.tillEvents.where("tillStatus").equals("open").toArray();
      trace("Till", "storeOps(NXT) openEvents", { count: tillEvents.length, date: tillEvents[0]?.openingTime?.split(" ")[0] });
      if (tillEvents.length > 0) {
        const currentDate = dayjs().format("YYYY-MM-DD");
        const tillEventDate = tillEvents[0]?.openingTime?.split(" ")[0];
        if (currentDate === tillEventDate) {
          return await getStoreOps(bunitId);
        } else {
          trace("Till", "day change detected (NXT) → /close-till", { currentDate, tillEventDate });
          const activeTillSession = useSessionStore.getState().tillSession;
          if (!activeTillSession) {
            trace("Till", "day change (NXT): no tillSession — orphaned open events, closing silently");
            await db.tillEvents.where("tillStatus").equals("open").modify({ tillStatus: "closed", isSynced: 1 });
            return await getStoreOps(bunitId);
          }
          setLoading(false);
          history.push("/close-till");
          return { redirected: true };
        }
      } else {
        const response = await getStoreOps(bunitId);
        if (response?.status === 200) {
          const storeOpsData = response?.data?.data?.getStoreOps;
          if (storeOpsData?.status === "OP") {
            return response;
          } else if (storeOpsData?.status === "CL") {
            const tillData = useAuthStore.getState().tillData;
            const tillValue = useAuthStore.getState().tillValue;

            // Calculate dates
            const closedDate = dayjs(storeOpsData?.businessDate || new Date()).format("DD/MM/YYYY");
            const nextBusinessDate = dayjs(storeOpsData?.businessDate || new Date())
              .add(1, "days")
              .format("DD/MM/YYYY");
            const closedTime = storeOpsData?.closedTime || "8:00 PM";

            setPostCloseData({
              storeClosedDate: closedDate,
              newBusinessDate: nextBusinessDate,
              closedTime: closedTime,
              tillId: tillValue?.name || tillData?.tillAccess?.cwrTill?.till || "N/A",
              cashierName: username || "N/A",
            });
            setPostCloseModalVisible(true);
            setLoading(false);
            return { redirected: true };
          } else if (!storeOpsData) {
            return response;
          }
        }
      }
    } else {
      const tillEvents = await db?.tillEvents.where("tillStatus").equals("open").toArray();
      trace("Till", "storeOps(normal) openEvents", { count: tillEvents.length, date: tillEvents[0]?.openingTime?.split(" ")[0] });
      if (tillEvents.length > 0) {
        const currentDate = dayjs().format("YYYY-MM-DD");
        const tillEventDate = tillEvents[0]?.openingTime?.split(" ")[0];
        if (currentDate === tillEventDate) {
          return await getStoreOps(bunitId);
        } else {
          trace("Till", "day change detected → /close-till", { currentDate, tillEventDate });
          const activeTillSession = useSessionStore.getState().tillSession;
          if (!activeTillSession) {
            trace("Till", "day change: no tillSession — orphaned open events, closing silently");
            await db.tillEvents.where("tillStatus").equals("open").modify({ tillStatus: "closed", isSynced: 1 });
            return await getStoreOps(bunitId);
          }
          setLoading(false);
          history.push("/close-till");
          return { redirected: true };
        }
      } else {
        return await getStoreOps(bunitId);
      }
    }
  };

  // Add handlers for the modal buttons
  const handlePostCloseContinue = async () => {
    setPostCloseModalVisible(false);
    setLoading(true);

    const tillEvents = await db?.tillEvents.where("tillStatus").equals("open").toArray();

    if (tillEvents.length > 0) {
      const tillSessionId = tillEvents[0]?.tillSessionId; // 🔹 rename event → currentEvent

      await db.ordersData
        .where("tillSessionId")
        .equals(tillSessionId)
        .modify((order) => {
          order.tillStatus = "closed";
        });

      await db.paymentsData
        .where("tillSessionId")
        .equals(tillSessionId)
        .modify((payment) => {
          payment.tillStatus = "closed";
        });

      await db.tillEvents
        .where("tillSessionId")
        .equals(tillSessionId)
        .modify((tillEvent) => {
          tillEvent.tillStatus = "closed";
          tillEvent.isSynced = 1;
          tillEvent.user = useAuthStore.getState().userData?.user;
        });
    }

    const userData = useAuthStore.getState().userData || {};
    const userid = userData?.user_id;
    // Use the date already computed from server response (shown in modal), not dayjs().add(1, "day")
    const nextBusinessDate = dayjs(postCloseData.newBusinessDate, "DD/MM/YYYY").format("YYYY-MM-DD HH:mm:ss");
    const response = await getStoreOps(JSON.parse(localStorage.getItem("tillValue"))?.cSBunitID, nextBusinessDate);
    if (response?.status === 200) {
      const storeOpsData = response?.data?.data?.getStoreOps;
      if (storeOpsData?.status === "OP") {
        useSessionStore.getState().setNextBusinessDate(nextBusinessDate);
        setTillValue({});
        history.push("/login");
      } else if (storeOpsData?.status === "CL" || storeOpsData === null) {
        const resStoreOps = await upsertStoreOps(JSON.parse(localStorage.getItem("tillValue"))?.cSBunitID, userid, nextBusinessDate);
        const upsertData = resStoreOps?.data?.data?.upsertStoreOps;

        if (upsertData?.status === "200") {
          useSessionStore.getState().setNextBusinessDate(nextBusinessDate);
          setTillValue({});
          history.push("/login");
        } else {
          message.error(upsertData?.message);
          setLoading(false);
        }
      }
    }
  };

  const handlePostCloseCancel = () => {
    setPostCloseModalVisible(false);
    // Logout logic
    onUserModal();
  };

  const parseRemarksProducts = (remarks) => {
    try {
      const match = remarks.match(/Result:\s*(\[.*\])/);
      if (match && match[1]) {
        let arrStr = match[1];

        // ✅ Quote keys (m_product_id → "m_product_id")
        arrStr = arrStr.replace(/(\w+):/g, '"$1":');

        // ✅ Quote string values that are not already quoted/null
        arrStr = arrStr.replace(/:"([^",\]\}]*)"(?![,\]\}])/g, (m, p1) => {
          // already quoted string, leave it
          return m;
        });
        arrStr = arrStr.replace(/:"?([^",\]\}]+)"?(?=[,\]\}])/g, (m, p1) => {
          if (p1 === "null") return ":null"; // keep null
          return `:"${p1.trim()}"`;
        });

        return JSON.parse(arrStr);
      }
    } catch (err) {
      console.error("Error parsing remarks:", err, remarks);
    }
    return [];
  };

  useEffect(() => {
    const runAsync = async () => {
    // Hydrate POS module stores now that we're entering the POS module.
    // These are kept out of App.js boot so non-POS modules (Inventory,
    // PurchaseOrder, etc.) don't pay the cost of loading POS state.
    await Promise.all([
      usePOSConfigStore.persist.rehydrate(),
      useCartStore.persist.rehydrate(),
      useSessionStore.persist.rehydrate(),
      useTransactionStore.persist.rehydrate(),
      useRestaurantStore.persist.rehydrate(),
      useReferenceStore.persist.rehydrate(),
    ]);

    // FIX 4: Recovery for stale tillSession on app restart
    // If a tillSession exists with "open" status but the till was never properly
    // opened in this session (no matching tillEvent in DB), clear the stale session
    // so the user can proceed with till selection without being blocked.
    const existingTillSession = useSessionStore.getState().tillSession;
    trace("Till", "stale check start", {
      hasTillSession: !!existingTillSession,
      tillStatus: existingTillSession?.tillStatus,
      tillSessionId: existingTillSession?.tillSessionId?.slice(0, 8),
    });
    if (existingTillSession && existingTillSession.tillStatus === "open") {
      try {
        const matchingEvents = await db.tillEvents
          .where("tillSessionId")
          .equals(existingTillSession.tillSessionId)
          .toArray();
        trace("Till", "stale check DB result", { matchCount: matchingEvents?.length });
        if (!matchingEvents || matchingEvents.length === 0) {
          // Stale session from a previous run — clear it so user can proceed
          trace("Till", "stale → clearing tillSession");
          console.warn("Clearing stale tillSession (no matching tillEvent in DB):", existingTillSession.tillSessionId);
          useSessionStore.getState().setTillSession(null);
        }
      } catch (err) {
        console.error("Error checking tillSession recovery:", err);
        trace("Till", "stale check DB ERROR — preserving session", { error: err?.message });
        // On DB error, preserve the session — it may still be valid.
        // handleStoreOpsService will detect a day-change if there is one.
      }
    }

    const tillRegistrations = await db.tillRegistrations.toArray();
    const posType = usePOSConfigStore.getState().posType;
    const posConfig = usePOSConfigStore.getState().posConfig;
    if (runEffect) {
      setRunEffect(!runEffect);
      const nameTill = tillValue?.name;
      if (nameTill && (username || email) && cleanToken && tillRegistrations.length > 0) {
        setLoading(true);
        const userData = Enterprise ? username : email;
        const syncSuccess = await syncTillData(userData, authHeaders);
        let tillData = useAuthStore.getState().tillData;
        if (!tillData || !syncSuccess) {
          console.warn("[Till] syncTillData failed or tillData missing after sync — falling back to getTillData()");
          retryCountRef.current += 1;
          setLoading(false);
          setTillLoadError(syncSuccess === false ? "sync_failed" : "no_till_data");
          getTillData();
          return;
        }
        if (tillData) {
          const tillAccessData = tillData.tillAccess;
          if (!tillAccessData || !Array.isArray(tillAccessData) || tillAccessData?.length === 0) {
            console.warn("[Till] tillAccess empty or not an array — falling back to getTillData()");
            retryCountRef.current += 1;
            setLoading(false);
            setTillLoadError("no_till_access");
            getTillData();
            return;
          }
          const tillAccessIndex = (tillAccessData || [])?.findIndex((accessTill) => accessTill.cwrTill.till === nameTill);
          if (tillAccessIndex >= 0 || (tillAccessData && typeof tillAccessData === "object" && !Array.isArray(tillAccessData))) {
            if (islocked) {
              try {
                tillData.tillAccess = tillAccessIndex >= 0 ? tillAccessData[tillAccessIndex] : tillAccessData;
                useAuthStore.getState().setUsername(username);
                tillData.time = dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss");
                useAuthStore.getState().setTillData(tillData);
              } catch (err) {
                console.error("Error during unlock till data lookup:", err);
              } finally {
                // Always clear lock state even if till data lookup fails
                useSessionStore.getState().setLocked(false);
              }
              setTillValue({});
              if (posType === "PRD") {
                history.push("/production");
              } else if (posConfig?.enableEstimate === "Y") {
                history.push("/estimate");
              } else {
                history.push("/pos");
              }
            } else if (posType === "PRD") {
              setTillValue({});
              history.push(`/login`);
            } else {
              const handleStoreOps = async () => {
                try {
                  tillData.tillAccess = tillAccessIndex >= 0 ? tillAccessData[tillAccessIndex] : tillAccessData;
                  tillData.time = dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss");
                  useAuthStore.getState().setTillData(tillData);
                  const salesReps = tillData?.tillAccess?.csBunit?.salesRep || [];
                  const matchedRep = salesReps.find((rep) => rep.name === username);
                  if (matchedRep) {
                    setTillValue({});
                    history.push(`/login`);
                  } else {
                    const result = await handleStoreOpsService(tillValue?.cSBunitID);
                    if (result?.redirected) return;
                    const storeOpsData = result?.data?.data?.getStoreOps;
                    if (result?.data?.data?.getStoreOps?.status === "ERR") {
                      setLoading(false);
                      const remarks = result?.data?.data?.getStoreOps?.remarks;
                      const products = parseRemarksProducts(remarks);
                      if (products.length > 0) {
                        setErrorProducts(products);
                        setErrorModalVisible(true);
                      } else {
                        message.error(remarks || `${messages.errors.system.unexpected_error}`);
                      }
                      return;
                    } else if (result?.data?.data?.getStoreOps?.status === "WAR") {
                      message.error(result?.data?.data?.getStoreOps?.remarks);
                    }
                    if (!storeOpsData) {
                      const resStoreOps = await upsertStoreOps(tillValue?.cSBunitID, tillData.tillAccess.csUserId);
                      const upsertData = resStoreOps?.data?.data?.upsertStoreOps;
                      if (upsertData?.status === "200") {
                        setTillValue({});
                        history.push(`/login`);
                      } else {
                        message.error(upsertData?.message);
                        setLoading(false);
                      }
                    } else if (storeOpsData.status === "OP") {
                      setTillValue({});
                      history.push(`/login`);
                    } else {
                      setTillValue({});
                      setLoading(false);
                      Modal.confirm({
                        title: `This till has been closed "${dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss")}"`,
                        icon: null,
                        cancelText: "",
                        okText: "Okay",
                        okButtonProps: { style: { display: "inline-block" } },
                        cancelButtonProps: { style: { display: "none" } }, // Disable the cancel button
                        onOk() {
                          getTillData();
                        },
                      });
                    }
                  }
                } catch (error) {
                  setTillValue({});
                  console.error("An error occurred:", error);
                  message.error(error);
                  setLoading(false);
                }
              };
              handleStoreOps();
            }
          } else {
            setTillValue({});
            setLoading(false);
            errorMessage("Login Failed", "User not configured for this Till", "user");
          }
        }
      } else {
        getTillData();
      }
    }
    };
    runAsync();
  }, [runEffect]);

  const getTillData = async () => {
    if (authHeaders && cleanToken && (username || email)) {
      setLoading(true);
      try {
        let userData = useAuthStore.getState().userData;
        // SSO bootstrap: if auth cookies exist but userData is missing, fetch it
        if (!userData?.user_id) {
          try {
            const { getGlobalParameters } = await import("../../services/generic");
            const gpRes = await getGlobalParameters();
            if (gpRes?.status === 200) {
              const parsed = JSON.parse(gpRes.data.data.getGlobalParameters);
              useAuthStore.getState().setUserData(parsed.User);
              userData = parsed.User;
              console.debug("[Till] SSO bootstrap: fetched userData", userData?.user_id);
            }
          } catch (err) {
            console.error("[Till] SSO bootstrap failed:", err);
          }
        }
        const userid = userData?.user_id;
        if (!userid) {
          console.warn("[Till] getTillData: no user_id — session expired, redirecting to sign-in");
          window.location.href = "/sign-in";
          return;
        }
        const response = await getTills(userid);
        const tillsData = response?.data?.data?.getTills ?? [];
        if (tillsData.length === 0) {
          console.warn("[Till] getTillData: API returned 0 tills for user", userid);
          setTillLoadError("no_tills_found");
        } else {
          retryCountRef.current = 0;
          setTillLoadError(null);
        }
        const transformedData = tillsData.reduce((result, item) => {
          const { name } = item;
          const existingGroupIndex = result.findIndex((group) => group[name]);
          if (existingGroupIndex === -1) {
            result.push({ [name]: [item] });
          } else {
            result[existingGroupIndex][name].push(item);
          }
          return result;
        }, []);
        setTills(transformedData);
      } catch (error) {
        retryCountRef.current += 1;
        if (!error.response) {
          console.error("Network error: Unable to connect to the server", error);
          setTillLoadError("network");
        } else {
          console.error("Error while fetching till data:", error);
          setTillLoadError("api_error");
        }
      } finally {
        setLoading(false);
      }
    } else {
      console.warn("[Till] getTillData: missing auth credentials — cannot fetch tills");
      setTillLoadError("no_auth");
      setLoading(false);
    }
  };

  const callTillRegistration = async (cwrTillID, search_key) => {
    try {
      const syncId = uuidv4().replace(/-/g, "").toUpperCase();
      const timeMark = timeStamp();
      const resData = await tillRegistration(syncId, cwrTillID, search_key, timeMark, username);
      const tillData = resData?.data?.data?.tillRegistration;
      if (tillData?.status === "200" && tillData.tillAccess?.length > 0) {
        localStorage.setItem("syncId", syncId);
        const cwrTill0 = tillData.tillAccess[0].cwrTill || {};
        const serverSeq0 = cwrTill0.nextAssignedNumber || 0;
        const localMax0 = await getLocalMaxSequence(db, cwrTill0.prefix);
        useSessionStore.getState().setDocumentSequence(Math.max(serverSeq0, localMax0));

        const preSeq0 = cwrTill0.preorderSequence ? { ...cwrTill0.preorderSequence } : null;
        if (preSeq0) {
          const lpMax0 = await getLocalMaxSequence(db, preSeq0.prefix);
          preSeq0.nextNo = Math.max(preSeq0.nextNo || 0, lpMax0);
        }
        useSessionStore.getState().setPreorderSequence(preSeq0);

        const canSeq0 = cwrTill0.cancelledOrderSequence ? { ...cwrTill0.cancelledOrderSequence } : null;
        if (canSeq0) {
          const lcMax0 = await getLocalMaxSequence(db, canSeq0.prefix);
          canSeq0.nextNo = Math.max(canSeq0.nextNo || 0, lcMax0);
        }
        useSessionStore.getState().setCancelledOrderSequence(canSeq0);

        const seqPrefixes0 = [cwrTill0.prefix, preSeq0?.prefix, canSeq0?.prefix].filter(Boolean);
        if (new Set(seqPrefixes0).size !== seqPrefixes0.length) {
          console.error("[SEQ] Duplicate prefixes detected — falling back to single sequence mode");
          useSessionStore.getState().setPreorderSequence(null);
          useSessionStore.getState().setCancelledOrderSequence(null);
        }

        await db.tillRegistrations.add(tillData);
        const activityResponse = await upsertPOSActivity(tillData);
        if (activityResponse?.data?.data?.upsertPOSActivity?.status === "200") {
          setTillValue({});
          history.push(`/login`);
        }
      } else {
        setTillValue({});
        throw new Error(tillData?.message || "Till registration failed.");
      }
    } catch (error) {
      setTillValue({});
      console.error("An error occurred:", error);
      setLoading(false);
      Modal.error({
        title: error.message || "An unexpected error occurred.",
        onOk() {
          // Stay on till selection — just dismiss the modal
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const onRegistration = async (search_key, csbUnitId, csUserId, cwrTillID) => {
    const userData = useAuthStore.getState().userData;
    const userid = userData?.user_id;
    let posConfig = {};
    if (username || email) {
      try {
        setLoading(true);
        const userData = Enterprise ? username : email;
        await syncTillData(userData, authHeaders);
        let tillData = useAuthStore.getState().tillData;
        useAuthStore.getState().setTillData(tillData);
        const posConfigResponse = await posConfigService(cwrTillID);
        if (posConfigResponse?.data?.data?.getPOSConfig?.length > 0) {
          posConfig = posConfigResponse.data.data.getPOSConfig[0];
          const posConfigData = JSON.parse(posConfig?.configJson || "{}");
          const feedbackData = JSON.parse(posConfig?.feedback || "{}");
          const registrationTypes = JSON.parse(posConfig?.registrationTypes || "[]");
          useReferenceStore.getState().setRegistrationTypes(registrationTypes);
          usePOSConfigStore.getState().setPosConfig(posConfigData);
          usePOSConfigStore.getState().setPosType(posConfig.posType);
          localStorage.setItem("posConfigData", JSON.stringify(posConfig));
          useReferenceStore.getState().setFeedbackJson(feedbackData);
        } else {
          errorMessage("Login Failed", "Error in getting POS configuration");
        }
        let matchedRep;
        if (tillData !== null && tillData !== undefined) {
          const tillAccessData = tillData.tillAccess;
          if (!tillAccessData || !Array.isArray(tillAccessData) || tillAccessData?.length === 0) {
            setLoading(false);
            errorMessage("Till Setup Error", "No till access data found. Please contact your administrator to configure till access for your account.");
            return;
          }
          const nameTill = useAuthStore.getState().tillValue?.name;
          const tillAccessIndex = (tillAccessData || [])?.findIndex((accessTill) => accessTill.cwrTill.till === nameTill);
          if (tillAccessIndex >= 0 || (tillAccessData && typeof tillAccessData === "object" && !Array.isArray(tillAccessData))) {
            tillData.tillAccess = tillAccessIndex >= 0 ? tillAccessData[tillAccessIndex] : tillAccessData;
            // Persist the processed tillAccess (single object, not array) so CloseTill
            // can read tillData.tillAccess.csBunit without getting undefined.
            tillData.time = dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss");
            useAuthStore.getState().setTillData(tillData);
            trace("Till", "onRegistration: setTillData after tillAccess fix", {
              isArray: Array.isArray(tillData.tillAccess),
              hasCsBunit: !!tillData.tillAccess?.csBunit,
            });
            const salesReps = tillData?.tillAccess?.csBunit?.salesRep || [];
            console.debug("username ==============>", username);
            matchedRep = salesReps.find((rep) => rep.name === username);
          }
        }
        if (posConfig?.posType === "PRD") {
          history.push("/login");
        } else if (matchedRep) {
          history.push("/login");
        } else {
          const result = await handleStoreOpsService(csbUnitId);
          if (result?.redirected) return;
          if (result?.data?.data?.getStoreOps?.status === "ERR") {
            setLoading(false);
            const remarks = result?.data?.data?.getStoreOps?.remarks;
            const products = parseRemarksProducts(remarks);
            if (products.length > 0) {
              setErrorProducts(products);
              setErrorModalVisible(true);
            } else {
              message.error(remarks || `${messages.errors.system.unexpected_error}`);
            }
            return;
          } else if (result?.data?.data?.getStoreOps?.status === "WAR") {
            message.error(result?.data?.data?.getStoreOps?.remarks);
          }
          if (result?.data?.data?.getStoreOps === null) {
            const resStoreOps = await upsertStoreOps(csbUnitId, userid);
            if (resStoreOps?.data?.data?.upsertStoreOps?.status === "200") {
              let syncId = uuidv4().replace(/-/g, "").toUpperCase();
              const timeMark = timeStamp();
              const resData = await tillRegistration(syncId, cwrTillID, search_key, timeMark, username);
              const tillData = resData.data.data.tillRegistration;
              localStorage.setItem("syncId", syncId);
              if (tillData?.status === "200") {
                await db.tillRegistrations.add(tillData);
                const cwrTill1 = tillData.tillAccess[0].cwrTill || {};
                const serverSeq1 = cwrTill1.nextAssignedNumber || 0;
                const localMax1 = await getLocalMaxSequence(db, cwrTill1.prefix);
                useSessionStore.getState().setDocumentSequence(Math.max(serverSeq1, localMax1));

                const preSeq1 = cwrTill1.preorderSequence ? { ...cwrTill1.preorderSequence } : null;
                if (preSeq1) {
                  const lpMax1 = await getLocalMaxSequence(db, preSeq1.prefix);
                  preSeq1.nextNo = Math.max(preSeq1.nextNo || 0, lpMax1);
                }
                useSessionStore.getState().setPreorderSequence(preSeq1);

                const canSeq1 = cwrTill1.cancelledOrderSequence ? { ...cwrTill1.cancelledOrderSequence } : null;
                if (canSeq1) {
                  const lcMax1 = await getLocalMaxSequence(db, canSeq1.prefix);
                  canSeq1.nextNo = Math.max(canSeq1.nextNo || 0, lcMax1);
                }
                useSessionStore.getState().setCancelledOrderSequence(canSeq1);

                const seqPrefixes1 = [cwrTill1.prefix, preSeq1?.prefix, canSeq1?.prefix].filter(Boolean);
                if (new Set(seqPrefixes1).size !== seqPrefixes1.length) {
                  console.error("[SEQ] Duplicate prefixes detected — falling back to single sequence mode");
                  useSessionStore.getState().setPreorderSequence(null);
                  useSessionStore.getState().setCancelledOrderSequence(null);
                }

                setLoading(false);
                const response = await upsertPOSActivity(tillData);
                if (response?.data?.data?.upsertPOSActivity?.status === 200 || response?.data?.data?.upsertPOSActivity?.status === "200") {
                  history.push(`/login`);
                }
              } else {
                setLoading(false);
                errorMessage(tillData.message);
              }
            } else {
              message.error(resStoreOps?.data?.data?.upsertStoreOps?.message);
              setTillValue({});
              setTimeout(() => {
                for (let key in localStorage) {
                  if (key !== "userData") {
                    localStorage.removeItem(key);
                  }
                }
                window.location.assign("/till");
              }, 3000);
            }
          } else if (result?.data?.data?.getStoreOps?.status === "OP") {
            await callTillRegistration(cwrTillID, search_key);
          } else {
            setLoading(false);
            Modal.confirm({
              title: `This till has been closed "${dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss")}"`,
              icon: null,
              cancelText: "",
              okText: "Okay",
              okButtonProps: { style: { display: "inline-block" } },
              cancelButtonProps: { style: { display: "none" } }, // Disable the cancel button
              onOk() {
                Modal.destroyAll();
              },
            });
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        errorMessage("Error", "An error occurred while fetching till data");
      }
    }
  };

  const onModalOkay = () => {
    setLoading(false);
    const keepKey = "userData"; // Replace with the key you want to keep
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key !== keepKey) {
        localStorage.removeItem(key);
      }
    }
  };

  const onUserModal = () => {
    const cookiesToDelete = document.cookie.split(";").map((cookie) => cookie.trim());
    const domainURL = process.env.REACT_APP_domain;
    const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
    const domainPart = isLocalhost ? "" : "domain=" + domainURL + ";";
    const securePart = isLocalhost ? "" : "secure=true;";
    for (let i = 0; i < cookiesToDelete.length; i++) {
      const cookie = cookiesToDelete[i];
      const eqPos = cookie.indexOf("=");
      const name = (eqPos > -1 ? cookie.substr(0, eqPos) : cookie).trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;${securePart}SameSite=Strict;${domainPart}`;
    }
    useSessionStore.getState().setTillSession(null);
    useSessionStore.getState().setLastUpdatedTime(null);
    window.electronAPI?.auth?.logout();
    window.location.assign(`${redirectUrl}sign-in`);
  };

  const errorMessage = (modalTitle, modalContent, user) => {
    Modal.error({
      title: modalTitle,
      content: modalContent,
      onOk: user ? onUserModal : onModalOkay,
    });
  };

  const onTill = () => {
    if (cleanToken !== "bearer undefined" && (email || username)) {
      setRunEffect(true);
    } else {
      history.push("/sign-in");
    }
  };

  return (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 36 }} className="spinLoader" spin />} spinning={loading}>
      {authHeaders ? (
        <Row>
          <Col style={{ backgroundColor: "#F5FAFF" }} span={8}>
            <div style={{ height: "100vh" }}>
              <Image preview={false} src={logo} style={{ paddingTop: "4.5vh", paddingLeft: "2.6em", width: "93%" }} />
              <p style={{ fontFamily: "Inter", fontWeight: 600, fontSize: "1.8vw", paddingTop: "7vh", paddingLeft: "3em", color: "#0F0718" }}>
                Welcome to Point of Sale
                {multilingual && <span style={{ display: "block" }}>{t("Welcome to Point of Sale")}</span>}
              </p>
              <Image preview={false} src={laptop3} style={{ width: "30vw", marginLeft: "2em", height: "43vh" }} />
              <p style={{ fontFamily: "Inter", fontWeight: 600, color: "#667085", fontSize: "13px", paddingTop: "7vh", paddingLeft: "3em" }}>Point of Sale </p>
              <p style={{ fontFamily: "Inter", fontWeight: 600, color: "#667085", fontSize: "0.9vw", paddingTop: "0.5em", paddingLeft: "3em", paddingRight: "5em" }}>
                {" "}
                Centralize the operations of your store, process transactions, manage inventory, follow orders, create reports of the store’s activities and much more!
              </p>
            </div>
          </Col>
          <Col span={16}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "1.5rem 2rem" }}>
              <p
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 600,
                  fontSize: "1.25rem", // 20px
                  color: "#0F0718",
                  margin: 0,
                }}
              >
                {getMultilingualText("Select a Till to login")}
              </p>
              <div style={{ display: "flex", alignItems: "center", gap: "1.5rem" }}>
                <div
                  onClick={() => history.push("/")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "6px 12px",
                    borderRadius: "6px",
                    border: "1px solid #e0e0e0",
                    backgroundColor: "#fff",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 500,
                      fontSize: "1rem",
                      color: "#0F0718",
                    }}
                  >
                    ← Home
                  </span>
                </div>
                <div
                  onClick={() => window.location.reload()}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <img src={SyncSide} alt="Refresh" style={{ height: "20px", width: "20px" }} />
                  <span
                    style={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 500,
                      fontSize: "1rem",
                      color: "#0F0718",
                      marginLeft: "0.5rem",
                    }}
                  >
                    Refresh
                  </span>
                </div>
                <div
                  onClick={() => history.push({ pathname: "/health", state: { from: "/till" } })}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "6px 12px",
                    borderRadius: "6px",
                    border: "1px solid #e0e0e0",
                    backgroundColor: "#fff",
                  }}
                >
                  <MedicineBoxOutlined style={{ fontSize: "16px", color: "#1890ff" }} />
                  <span
                    style={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 500,
                      fontSize: "1rem",
                      color: "#1890ff",
                      marginLeft: "0.5rem",
                    }}
                  >
                    Diagnostics
                  </span>
                </div>
              </div>
            </div>
            <Scrollbars style={{ height: "85vh" }}>
              {/* Error banner — visible even when tills are listed, so user knows something failed */}
              {tillLoadError && !loading && (tills?.length > 0 || tillValue?.search_key) && (
                <Alert
                  type={retryCountRef.current >= MAX_RETRIES ? "error" : "warning"}
                  showIcon
                  closable
                  style={{ margin: "0 2em 1em 2em" }}
                  message={
                    tillLoadError === "sync_failed"
                      ? "Till sync failed — your session data may be outdated"
                      : tillLoadError === "no_till_data"
                      ? "Could not load till configuration from server"
                      : tillLoadError === "no_till_access"
                      ? "Server returned no till access — your user may not be assigned to a till on the backend"
                      : tillLoadError === "network"
                      ? "Network connection failed"
                      : tillLoadError === "api_error"
                      ? "Server returned an error"
                      : "An issue was detected"
                  }
                  description={
                    <span>
                      {retryCountRef.current >= MAX_RETRIES
                        ? "Multiple attempts failed. This is likely a backend configuration issue, not a network problem. "
                        : "You can still select a till below, but it may not work until this is resolved. "}
                      <a
                        href="/health"
                        onClick={(e) => { e.preventDefault(); history.push({ pathname: "/health", state: { from: "/till" } }); }}
                        style={{ fontWeight: 600, cursor: "pointer" }}
                      >
                        <MedicineBoxOutlined /> Run Diagnostics
                      </a>
                    </span>
                  }
                />
              )}

              {authHeaders?.access_token &&
                (authHeaders?.username || authHeaders?.email) &&
                tills?.map((e, index) => (
                  <div key={index} style={{ marginLeft: "2em", marginBottom: "1.5em" }}>
                    <p
                      style={{
                        fontFamily: "Inter",
                        fontWeight: 600,
                        fontSize: "1vw",
                        paddingTop: "1.5em",
                        paddingLeft: "0.2em",
                        color: "#585768",
                        marginBottom: "0.5em",
                      }}
                    >
                      {Object.keys(e)[0]}
                    </p>

                    {/* 🔄 Responsive Flex Container */}
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "0.8rem",
                      }}
                    >
                      {e[Object.keys(e)[0]].map((res) => (
                        <Card
                          key={res.cwrTillID}
                          id="step1"
                          styles={{ body: { padding: "1vw", paddingBottom: 0 } }}
                          style={{
                            flex: "1 1 calc(20% - 1.5rem)",
                            minWidth: "10.5em",
                            maxWidth: "11em",
                            height: "8em",
                            borderRadius: "6px",
                            border: "1px solid #EEEEEF",
                            boxShadow: "0px 0px 10px 1px rgba(0, 0, 0, 0.04)",
                            backgroundColor: "#F3F4F9",
                            cursor: "pointer",
                            position: "relative",
                            display: "flex",
                            flexDirection: "column",
                          }}
                          onClick={() => {
                            useAuthStore.getState().setTillValue({
                              search_key: res.searchKey,
                              cwr_till_id: res.cwrTillID,
                              name: res.till,
                              cSBunitID: res.cSBunitID,
                            });
                            onRegistration(res.searchKey, res.cSBunitID, res.cSUserId, res.cwrTillID);
                          }}
                        >
                          <div style={{ flexGrow: 1 }}>
                            <div>
                              <Image preview={false} src={posImg} style={{ height: "1.5vw" }} />
                              <span style={{ marginLeft: "1em", color: "#0F0718" }}>{res.till}</span>
                            </div>
                          </div>

                          <div style={{ position: "absolute", bottom: 0, left: "1vw" }}>
                            <Image preview={false} src={res.status === "AVL" ? green : res.status === "INU" ? red : green} style={{ height: "0.9vw" }} />
                            <span
                              style={{
                                marginLeft: "5px",
                                fontSize: "1vw",
                                fontWeight: 600,
                                color: "#0F0718",
                              }}
                            >
                              {res.status === "AVL" ? "Available" : res.status === "INU" ? "In Use" : "Not Registered"}
                            </span>
                            <p
                              style={{
                                fontFamily: "Inter",
                                fontWeight: 600,
                                color: "#667085",
                                fontSize: "0.9vw",
                                marginBottom: "7px",
                              }}
                            >
                              {/* {res.userName} */}
                            </p>
                          </div>
                        </Card>
                      ))}
                    </div>
                  </div>
                ))}

              {/* ✅ Active Till (Same Responsive Layout) */}
              {!tills && tillValue?.search_key && (
                <div style={{ marginLeft: "2em", marginBottom: "2em" }}>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "0.5rem",
                    }}
                  >
                    <Card
                      id="step1"
                      key={tillValue?.cwrTillID}
                      styles={{ body: { padding: "1vw" } }}
                      style={{
                        height: "7.5em",
                        width: "11em",
                        borderRadius: "6px",
                        border: "1px solid #EEEEEF",
                        boxShadow: "0px 0px 10px 1px rgba(0, 0, 0, 0.04)",
                        backgroundColor: "#F3F4F9",
                        cursor: "pointer",
                      }}
                      onClick={onTill}
                    >
                      <div>
                        <Image preview={false} src={posImg} style={{ height: "1.5vw" }} />
                        <span style={{ marginLeft: "1em", top: "15px" }}>{tillValue?.name}</span>
                      </div>
                      <div style={{ paddingTop: "1em" }}>
                        <span style={{ marginLeft: "5px", fontSize: "1vw", fontWeight: 600 }}></span>
                      </div>
                      <p
                        style={{
                          fontFamily: "Inter",
                          fontWeight: 600,
                          marginLeft: "1.3em",
                          color: "#667085",
                          fontSize: "0.9vw",
                        }}
                      >
                        {tillValue?.userName}
                      </p>
                    </Card>
                  </div>
                </div>
              )}

              {!loading && !tills?.length && !tillValue?.search_key && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "60vh",
                    textAlign: "center",
                    padding: "2em",
                  }}
                >
                  <div
                    style={{
                      width: "64px",
                      height: "64px",
                      borderRadius: "50%",
                      backgroundColor: "#FFF3E0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "1.5em",
                    }}
                  >
                    <span style={{ fontSize: "28px" }}>!</span>
                  </div>
                  <p
                    style={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 600,
                      fontSize: "1.2rem",
                      color: "#0F0718",
                      marginBottom: "0.5em",
                    }}
                  >
                    {tillLoadError === "network"
                      ? "Unable to Connect"
                      : tillLoadError === "no_user"
                      ? "User Session Expired"
                      : tillLoadError === "no_tills_found"
                      ? "No Tills Available"
                      : tillLoadError === "sync_failed"
                      ? "Sync Failed"
                      : tillLoadError === "no_auth"
                      ? "Authentication Required"
                      : "No Tills Found"}
                  </p>
                  <p
                    style={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 400,
                      fontSize: "0.95rem",
                      color: "#667085",
                      maxWidth: "400px",
                      marginBottom: "1.5em",
                      lineHeight: 1.5,
                    }}
                  >
                    {tillLoadError === "network"
                      ? "Could not connect to the server. Please check your internet connection and try again."
                      : tillLoadError === "no_user"
                      ? "Your session could not be verified. Please log out and log in again."
                      : tillLoadError === "no_tills_found"
                      ? "No tills are configured for your account. Please contact your administrator to assign a CWR Till."
                      : tillLoadError === "sync_failed"
                      ? "Could not sync till data from the server. This may happen after a tenant switch or app update. Please try refreshing."
                      : tillLoadError === "no_till_access"
                      ? "The server returned null for till access (getTillAccess). This usually means your user is not assigned to a till on the backend, or the server's JDBC connection pool is exhausted. Contact your administrator."
                      : tillLoadError === "no_till_data"
                      ? "Till configuration returned empty from the server. The backend service may be down or misconfigured."
                      : tillLoadError === "no_auth"
                      ? "Authentication credentials are missing. Please log out and log in again."
                      : "No tills were found. Please try refreshing the page."}
                  </p>
                  {retryCountRef.current >= MAX_RETRIES && (
                    <p
                      style={{
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 500,
                        fontSize: "0.85rem",
                        color: "#ff4d4f",
                        maxWidth: "400px",
                        marginBottom: "1em",
                        lineHeight: 1.5,
                      }}
                    >
                      {retryCountRef.current} consecutive attempts have failed. This is likely a server-side issue — retrying will not help until the backend is fixed.
                    </p>
                  )}
                  <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", justifyContent: "center" }}>
                    <Button
                      type="primary"
                      onClick={() => {
                        setTillLoadError(null);
                        setTills(undefined);
                        getTillData();
                      }}
                      style={{
                        height: "40px",
                        borderRadius: "8px",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 500,
                      }}
                    >
                      Retry
                    </Button>
                    <Button
                      icon={<MedicineBoxOutlined />}
                      onClick={() => history.push({ pathname: "/health", state: { from: "/till" } })}
                      style={{
                        height: "40px",
                        borderRadius: "8px",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 500,
                      }}
                    >
                      Run Diagnostics
                    </Button>
                    {(tillLoadError === "no_user" || tillLoadError === "no_auth") && (
                      <Button
                        onClick={onUserModal}
                        style={{
                          height: "40px",
                          borderRadius: "8px",
                          fontFamily: "Inter, sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        Log Out
                      </Button>
                    )}
                  </div>
                </div>
              )}
            </Scrollbars>
          </Col>
          <Modal
            title="Stock Count Check Failed"
            open={errorModalVisible}
            onOk={() => setErrorModalVisible(false)}
            footer={[
              <Button key="ok" type="primary" onClick={() => setErrorModalVisible(false)}>
                OK
              </Button>,
            ]}
            onCancel={() => setErrorModalVisible(false)}
            centered
            width="70%"
          >
            <Table
              columns={[
                { title: "Item Name", dataIndex: "item_name", key: "item_name" },
                { title: "Item Code", dataIndex: "item_code", key: "item_code" },
              ]}
              dataSource={errorProducts}
              rowKey="item_code"
              pagination={false}
              size="small"
              scroll={{ x: "100%", y: "calc(100vh - 300px)" }}
            />
          </Modal>
        </Row>
      ) : (
        <Row></Row>
      )}
      <PostCloseSalesModal
        open={postCloseModalVisible}
        storeClosedDate={postCloseData.storeClosedDate}
        newBusinessDate={postCloseData.newBusinessDate}
        closedTime={postCloseData.closedTime}
        tillId={postCloseData.tillId}
        cashierName={postCloseData.cashierName}
        onContinue={handlePostCloseContinue}
        onCancel={handlePostCloseCancel}
      />
    </Spin>
  );
};
export default Till;
